var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownSearchIcon = function SvgDropdownSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.312 4.156a3.156 3.156 0 1 1-6.312 0 3.156 3.156 0 0 1 6.312 0Z",
    stroke: "#767676",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.425 6.425 8 8",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgDropdownSearchIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgOSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNy4zMTE3MyA0LjE1NTg2QzcuMzExNzMgNS44OTg3OSA1Ljg5ODc5IDcuMzExNzMgNC4xNTU4NiA3LjMxMTczQzIuNDEyOTQgNy4zMTE3MyAxIDUuODk4NzkgMSA0LjE1NTg2QzEgMi40MTI5NCAyLjQxMjk0IDEgNC4xNTU4NiAxQzUuODk4NzkgMSA3LjMxMTczIDIuNDEyOTQgNy4zMTE3MyA0LjE1NTg2WiIgc3Ryb2tlPSIjNzY3Njc2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjQyNDggNi40MjQ3MUw4LjAwMDAxIDcuOTk5OTIiIHN0cm9rZT0iIzc2NzY3NiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";